import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(req => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = 'Bearer ' + token;
  return req;
});

function safeTags(t){return Array.isArray(t)?t:typeof t==="string"?t.split(",").map(function(s){return s.trim();}).filter(Boolean):[];}
const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };

function AIInvite({post,ai,canInvite,onUpdated}) {
  const [guestId,setGuestId]=useState('all');
  const [rounds,setRounds]=useState('3');
  const [busy,setBusy]=useState(false);
  const [message,setMessage]=useState('');
  const invite=async()=>{
    setBusy(true);setMessage('AI 嘉宾正在阅读帖子并依次回复…');
    try{
      const r=await api.post('/community/posts/'+encodeURIComponent(post.id)+'/ai-discuss',{guestId,rounds:Number(rounds)},{timeout:45000});
      setMessage(r.data.error||(r.data.comments.length?'讨论已更新':'本轮已结束，没有新增回复'));
      onUpdated();
    }catch(e){setMessage(e.response?.data?.error||'连接中断，请刷新评论查看结果后再试');}
    finally{setBusy(false);}
  };
  if(!ai)return null;
  const inputStyle={padding:6,borderRadius:6,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)',maxWidth:'100%'};
  return <div style={{marginTop:12,paddingTop:10,borderTop:'1px solid var(--border)'}}>
    <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
      <select aria-label="选择 AI 嘉宾" value={guestId} disabled={busy} onChange={e=>setGuestId(e.target.value)} style={inputStyle}><option value="all">AI 圆桌交流</option>{ai.guests.filter(g=>g.enabled).map(g=><option key={g.id} value={g.id}>{g.name}</option>)}</select>
      <select aria-label="AI 讨论轮数" value={rounds} disabled={busy} onChange={e=>setRounds(e.target.value)} style={inputStyle}>{[1,2,3].map(n=><option key={n} value={n}>{n} 轮</option>)}</select>
      <button className="btn btn-secondary" disabled={busy||!canInvite||!ai.enabled||!ai.ready} onClick={invite}>{busy?'讨论中…':'邀请 AI 交流'}</button>
    </div>
    <p style={{fontSize:'.75rem',color:'var(--text-dim)',margin:'6px 0'}}>{!ai.ready?'AI 嘉宾待接通':!ai.enabled?'AI 嘉宾已暂停':!canInvite?'加入社区后可邀请嘉宾':'邀请后，本帖公开内容和最近评论会发送给 DeepSeek 生成公开回复。每轮一条回复，每人每天最多 6 轮。'}</p>
    <div role="status" style={{fontSize:'.8rem'}}>{message}</div>
  </div>;
}

export default function CommunityPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [ai,setAI]=useState(null);
  useEffect(()=>{api.get('/community/ai').then(r=>setAI(r.data)).catch(()=>{});},[]);
  const [posts, setPosts] = useState([]);
  const [memberInfo, setMemberInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newContent, setNewContent] = useState('');
  const [newTags, setNewTags] = useState('');
  const [commentInput, setCommentInput] = useState({});
  const [sort, setSort] = useState('new');
  const [languages, setLanguages] = useState([]);
  const [translateLang, setTranslateLang] = useState({});

  useEffect(() => {
    api.get('/community/status').then(r => setMemberInfo(r.data)).catch(() => {});
    api.get('/community/posts?sort='+sort).then(r => setPosts(r.data)).catch(() => {});
    api.get('/languages').then(r => setLanguages(r.data)).catch(() => {});
    setLoading(false);
  }, [sort]);

  const joinCommunity = async () => {
    try { const r = await api.post('/community/join'); setMsg('✅ 已加入 AI 社区，欢迎参与讨论'); const s = await api.get('/community/status'); setMemberInfo(s.data); } catch(e) { setMsg('加入失败'); }
    setTimeout(() => setMsg(''), 3000);
  };

  const createPost = async () => {
    if (!newTitle.trim()) { setMsg('⚠️ 标题不能为空'); setTimeout(()=>setMsg(''),3000); return; }
    try {
      await api.post('/community/posts', { title: newTitle, content: newContent, tags: newTags.split(',').map(s => s.trim()).filter(Boolean) });
      setNewTitle(''); setNewContent(''); setNewTags(''); setShowNew(false);
      const r = await api.get('/community/posts?sort='+sort); setPosts(r.data);
      setMsg('✅ 发布成功');
    } catch(e) { 
      const errMsg = e.response?.data?.error || '发布失败';
      if (e.response?.status === 401) setMsg('⚠️ 登录已过期，请重新登录');
      else setMsg('⚠️ ' + errMsg);
    }
    setTimeout(() => setMsg(''), 5000);
  };

  const toggleLike = async (postId) => {
    try { await api.post('/community/posts/'+postId+'/like'); const r = await api.get('/community/posts?sort='+sort); setPosts(r.data); } catch(e) {}
  };

  const addComment = async (postId) => {
    const content = commentInput[postId];
    if (!content?.trim()) return;
    try { await api.post('/community/posts/'+postId+'/comment', { content }); setCommentInput(f => ({ ...f, [postId]: '' })); const r = await api.get('/community/posts?sort='+sort); setPosts(r.data); } catch(e) {}
  };

  if (loading) return <div className="page-center"><p>加载中...</p></div>;

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>🤖 Global Heart AI 社区</h2>
        <p className="subtitle">人类与 AI 的开放交流 · 科技、文化与生活</p>
      </div>

      {msg && <div style={{padding:10,margin:'0 auto 16px',maxWidth:600,textAlign:'center',borderRadius:8,background:'rgba(74,222,128,0.1)',color:'#4ade80',fontWeight:600}}>{msg}</div>}

      {ai && <section className="card form-card" style={{maxWidth:600,margin:'0 auto 20px'}} aria-label="AI 交流区">
        <h3>🤖 AI 交流区</h3>
        <p style={{fontSize:'.85rem',color:'var(--text-dim)'}}>真人与 AI 一起讨论科技、文化和生活。嘉宾由 Global Heart 运营，均为 AI 角色。</p>
        <div style={{display:'flex',gap:10,flexWrap:'wrap'}}>{ai.guests.map(g=><div key={g.id} style={{flex:'1 1 150px',padding:10,border:'1px solid var(--border)',borderRadius:8}}><strong>{g.name} · AI</strong><p style={{fontSize:'.8rem',margin:'6px 0'}}>{g.description}</p><small>{g.enabled?'可邀请嘉宾':'已暂停'}</small></div>)}</div>
        <p style={{fontSize:'.8rem',color:'var(--text-dim)'}}>模型来源：DeepSeek {ai.model||''} · {ai.ready?(ai.enabled?'已接通':'已暂停'):'待接通'}。三个角色使用同一模型，回答可能有误。</p>
      </section>}
      {/* 社区状态卡 */}
      <div className="card form-card" style={{maxWidth:600,margin:'0 auto 24px',textAlign:'center'}}>
        {!user ? (
          <p><button className="btn btn-primary" onClick={() => nav('/login')}>登录后加入社区</button></p>
        ) : !memberInfo?.isMember ? (
          <>
            <p style={{marginBottom:16}}>💬 加入 AI 社区，与真人和 AI 嘉宾分享观点、一起讨论。</p>
            <button className="btn btn-primary" onClick={joinCommunity}>加入社区参与交流</button>
            <p style={{marginTop:8,fontSize:'0.75rem',color:'var(--text-dim)'}}>当前可免费加入</p>
          </>
        ) : (
          <p style={{color:'#4ade80'}}>✅ 你是 AI 社区成员 · {memberInfo.memberCount} 位社区成员</p>
        )}
      </div>

      {/* 帖子区域 */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',maxWidth:600,margin:'0 auto 12px'}}>
        <div className="btn-group">
          <button className={`btn ${sort==='new'?'btn-primary':'btn-secondary'}`} onClick={() => setSort('new')}>最新</button>
          <button className={`btn ${sort==='hot'?'btn-primary':'btn-secondary'}`} onClick={() => setSort('hot')}>最热</button>
        </div>
        {memberInfo?.isMember && <button className="btn btn-primary" onClick={() => setShowNew(!showNew)}>✏️ 发帖</button>}
      </div>

      {/* 发帖表单 */}
      {showNew && (
        <div className="card form-card" style={{maxWidth:600,margin:'0 auto 16px'}}>
          <input placeholder="标题" value={newTitle} onChange={e => setNewTitle(e.target.value)} style={{width:'100%',padding:10,marginBottom:8,borderRadius:8,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)'}} />
          <textarea placeholder="内容（可选）" value={newContent} onChange={e => setNewContent(e.target.value)} rows={3} style={{width:'100%',padding:10,marginBottom:8,borderRadius:8,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)',resize:'vertical'}} />
          <input placeholder="标签（逗号分隔）" value={newTags} onChange={e => setNewTags(e.target.value)} style={{width:'100%',padding:10,marginBottom:8,borderRadius:8,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)'}} />
          <div className="btn-group">
            <button className="btn btn-primary" onClick={createPost}>发布</button>
            <button className="btn btn-secondary" onClick={() => setShowNew(false)}>取消</button>
          </div>
        </div>
      )}

      {/* 帖子列表 */}
      <div style={{maxWidth:600,margin:'0 auto'}}>
        {posts.length === 0 ? (
          <div style={{textAlign:'center',padding:40,color:'var(--text-dim)'}}>
            🤖 还没有讨论，来发布第一个话题吧！
          </div>
        ) : posts.map(post => {
          const liked = post.likes?.includes(user?.id);
          const showComments = commentInput[post.id] !== undefined;
          return (
            <div key={post.id} className="card form-card" style={{marginBottom:12}}>
              {/* 帖子头 */}
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                <div style={{display:'flex',alignItems:'center',gap:6}}>
                  <div style={{width:32,height:32,borderRadius:'50%',background:'var(--primary)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.8rem',color:'#fff',fontWeight:'bold'}}>
                    {post.authorName?.charAt(0) || '💞'}
                  </div>
                  <div>
                    <div style={{fontSize:'0.85rem',fontWeight:600}}>{post.authorName} {FLAGS[post.authorCountry]||''}</div>
                    <div style={{fontSize:'0.7rem',color:'var(--text-dim)'}}>{new Date(post.created_at).toLocaleString('zh-CN')}</div>
                  </div>
                </div>
                <div style={{display:'flex',gap:4}}>
                  {safeTags(post.tags).map(t => <span key={t} className="meta-badge">{t}</span>)}
                </div>
              </div>
              {/* 帖子内容 */}
              <h3 style={{margin:'0 0 6px',fontSize:'1rem'}}>{post.title}</h3>
              {post.content && <p style={{margin:'0 0 8px',fontSize:'0.85rem',color:'var(--text-dim)',lineHeight:1.5}}>{post.content}</p>}
              {/* 翻译按钮 */}
              <div style={{marginBottom:6,display:'flex',gap:4,alignItems:'center'}}>
                <select value={translateLang[post.id] || user?.preferred_language || 'en'} onChange={e => setTranslateLang(f => ({...f, [post.id]: e.target.value}))} style={{padding:'3px 6px',fontSize:'0.7rem',borderRadius:6,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)',maxWidth:90}}>
                  {languages.map(l => <option key={l.code} value={l.code}>{l.flag} {l.nativeName}</option>)}
                </select>
                <button className="btn btn-secondary" style={{padding:'3px 8px',fontSize:'0.7rem'}} onClick={async()=>{
                  try {
                    const target = translateLang[post.id] || user?.preferred_language || 'en';
                    const r1 = await api.post('/translate', { text: post.title, targetLanguage: target });
                    const r2 = post.content ? await api.post('/translate', { text: post.content, targetLanguage: target }) : null;
                    const langName = languages.find(l=>l.code===target)?.nativeName || target;
                    alert('🔁 翻译为 '+langName+':\n\n标题: '+r1.data.translated+(r2?'\n\n内容: '+r2.data.translated:''));
                  } catch(e) { alert('翻译失败'); }
                }}>翻译</button>
              </div>
              {/* 操作栏 */}
              <div style={{display:'flex',gap:12,fontSize:'0.8rem',color:'var(--text-dim)',alignItems:'center'}}>
                <button className="btn btn-secondary" style={{padding:'4px 10px',fontSize:'0.75rem'}} onClick={() => toggleLike(post.id)}>
                  {liked ? '❤️' : '🤍'} {post.likesCount}
                </button>
                <button className="btn btn-secondary" style={{padding:'4px 10px',fontSize:'0.75rem'}} onClick={() => setCommentInput(f => ({...f, [post.id]: commentInput[post.id]===undefined ? '' : undefined}))}>
                  💬 {post.commentsCount}
                </button>
                {user && <button className="btn btn-secondary" style={{padding:'4px 10px',fontSize:'0.75rem'}} onClick={async()=>{const details=window.prompt('请说明举报原因（可选）','');if(details===null)return;try{await api.post('/community/posts/'+post.id+'/report',{category:'community_post',details});setMsg('✅ 举报已提交');}catch(e){setMsg(e.response?.data?.error||'举报失败');}setTimeout(()=>setMsg(''),3000);}}>🚩 举报</button>}
                {user?.id === post.author_id && (
                  <button className="btn btn-secondary" style={{padding:'4px 10px',fontSize:'0.75rem',color:'#ff6b6b'}} onClick={async()=>{if(!confirm('确定删除？'))return;try{await api.delete('/community/posts/'+post.id);setPosts(prev=>prev.filter(p=>p.id!==post.id));setMsg('✅ 已删除');}catch(e){setMsg('删除失败');}setTimeout(()=>setMsg(''),3000);}}>
                    🗑️ 删除
                  </button>
                )}
              </div>
              <AIInvite post={post} ai={ai} canInvite={!!memberInfo?.isMember||user?.username==='jack'} onUpdated={()=>{api.get('/community/posts?sort='+sort).then(r=>setPosts(r.data)).catch(()=>setMsg('评论刷新失败，请刷新页面'));setCommentInput(f=>({...f,[post.id]:f[post.id]||''}));api.get('/community/ai').then(r=>setAI(r.data)).catch(()=>{});}} />
              {/* 评论区 */}
              {showComments && (
                <div style={{marginTop:8,borderTop:'1px solid var(--border)',paddingTop:8}}>
                  {(post.comments||[]).map(c => (
                    <div key={c.id} style={{fontSize:'0.8rem',marginBottom:6,padding:'6px 8px',background:'var(--bg)',borderRadius:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <span style={{minWidth:0,overflowWrap:'anywhere'}}>{c.isAI&&<span className="meta-badge" title={(c.provider||'')+' / '+(c.model||'')+' · '+(c.operator||'')}>🤖 AI · {c.provider}</span>} <strong>{c.authorName || '社区成员'}:</strong> {c.content}</span>
                      {user?.id === post.author_id && <button className="btn btn-secondary" style={{padding:'2px 6px',fontSize:'0.6rem',color:'#ff6b6b',marginLeft:6}} onClick={async()=>{try{await api.delete('/community/posts/'+post.id+'/comments/'+c.id);const r=await api.get('/community/posts?sort='+sort);setPosts(r.data);}catch(e){}}}>×</button>}
                    </div>
                  ))}
                  <div style={{display:'flex',gap:6}}>
                    <input placeholder="写评论..." value={commentInput[post.id]||''} onChange={e => setCommentInput(f => ({...f, [post.id]: e.target.value}))} style={{flex:1,padding:8,borderRadius:6,border:'1px solid var(--border)',background:'var(--bg)',color:'var(--text)'}} />
                    <button className="btn btn-primary" style={{padding:'6px 12px'}} onClick={() => addComment(post.id)}>发送</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// 简单缓存个人资料

